export const COPY_ANIMATION_DURATION = 1600;
